module.exports = __webpack_public_path__ + "static/img/12.66a1e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/12.png
// module id = 6WGG
// module chunks = 0